module.exports = [
	{
		"age": "16",
		"thirtyDay": "60.86",
		"sixtyDay": "32.62",
		"ninetyDay": "20.9"
	},
	{
		"age": "17",
		"thirtyDay": "60.86",
		"sixtyDay": "32.71",
		"ninetyDay": "21.13"
	},
	{
		"age": "18",
		"thirtyDay": "60.86",
		"sixtyDay": "32.83",
		"ninetyDay": "21.32"
	},
	{
		"age": "19",
		"thirtyDay": "61.83",
		"sixtyDay": "33.59",
		"ninetyDay": "21.87"
	},
	{
		"age": "20",
		"thirtyDay": "63.34",
		"sixtyDay": "34.55",
		"ninetyDay": "22.72"
	},
	{
		"age": "21",
		"thirtyDay": "65",
		"sixtyDay": "35.62",
		"ninetyDay": "23.48"
	},
	{
		"age": "22",
		"thirtyDay": "67.08",
		"sixtyDay": "36.92",
		"ninetyDay": "24.54"
	},
	{
		"age": "23",
		"thirtyDay": "70.13",
		"sixtyDay": "38.75",
		"ninetyDay": "25.94"
	},
	{
		"age": "24",
		"thirtyDay": "73.19",
		"sixtyDay": "40.67",
		"ninetyDay": "27.34"
	},
	{
		"age": "25",
		"thirtyDay": "76.64",
		"sixtyDay": "42.72",
		"ninetyDay": "28.86"
	},
	{
		"age": "26",
		"thirtyDay": "79.98",
		"sixtyDay": "44.77",
		"ninetyDay": "30.47"
	},
	{
		"age": "27",
		"thirtyDay": "83.3",
		"sixtyDay": "46.93",
		"ninetyDay": "32.08"
	},
	{
		"age": "28",
		"thirtyDay": "87.17",
		"sixtyDay": "49.28",
		"ninetyDay": "33.91"
	},
	{
		"age": "29",
		"thirtyDay": "90.93",
		"sixtyDay": "51.54",
		"ninetyDay": "35.75"
	},
	{
		"age": "30",
		"thirtyDay": "94.79",
		"sixtyDay": "54.02",
		"ninetyDay": "37.56"
	},
	{
		"age": "31",
		"thirtyDay": "101.31",
		"sixtyDay": "58",
		"ninetyDay": "40.46"
	},
	{
		"age": "32",
		"thirtyDay": "107.96",
		"sixtyDay": "61.97",
		"ninetyDay": "43.48"
	},
	{
		"age": "33",
		"thirtyDay": "115.18",
		"sixtyDay": "66.28",
		"ninetyDay": "46.7"
	},
	{
		"age": "34",
		"thirtyDay": "122.79",
		"sixtyDay": "70.79",
		"ninetyDay": "50.14"
	},
	{
		"age": "35",
		"thirtyDay": "130.56",
		"sixtyDay": "75.51",
		"ninetyDay": "53.59"
	},
	{
		"age": "36",
		"thirtyDay": "137.74",
		"sixtyDay": "79.83",
		"ninetyDay": "56.92"
	},
	{
		"age": "37",
		"thirtyDay": "145.08",
		"sixtyDay": "84.34",
		"ninetyDay": "60.25"
	},
	{
		"age": "38",
		"thirtyDay": "152.73",
		"sixtyDay": "88.85",
		"ninetyDay": "63.6"
	},
	{
		"age": "39",
		"thirtyDay": "160.2",
		"sixtyDay": "93.27",
		"ninetyDay": "67.02"
	},
	{
		"age": "40",
		"thirtyDay": "167.69",
		"sixtyDay": "97.67",
		"ninetyDay": "70.25"
	},
	{
		"age": "41",
		"thirtyDay": "175.14",
		"sixtyDay": "102.19",
		"ninetyDay": "73.58"
	},
	{
		"age": "42",
		"thirtyDay": "182.92",
		"sixtyDay": "106.7",
		"ninetyDay": "76.91"
	},
	{
		"age": "43",
		"thirtyDay": "190.54",
		"sixtyDay": "111.12",
		"ninetyDay": "80.16"
	},
	{
		"age": "44",
		"thirtyDay": "197.9",
		"sixtyDay": "115.42",
		"ninetyDay": "83.38"
	},
	{
		"age": "45",
		"thirtyDay": "205.23",
		"sixtyDay": "119.74",
		"ninetyDay": "86.48"
	},
	{
		"age": "46",
		"thirtyDay": "213.81",
		"sixtyDay": "124.66",
		"ninetyDay": "90.05"
	},
	{
		"age": "47",
		"thirtyDay": "222.55",
		"sixtyDay": "129.72",
		"ninetyDay": "93.82"
	},
	{
		"age": "48",
		"thirtyDay": "231.27",
		"sixtyDay": "134.89",
		"ninetyDay": "97.46"
	},
	{
		"age": "49",
		"thirtyDay": "240.12",
		"sixtyDay": "139.93",
		"ninetyDay": "101.23"
	},
	{
		"age": "50",
		"thirtyDay": "249.55",
		"sixtyDay": "145.41",
		"ninetyDay": "105.21"
	},
	{
		"age": "51",
		"thirtyDay": "260.64",
		"sixtyDay": "151.87",
		"ninetyDay": "110.04"
	},
	{
		"age": "52",
		"thirtyDay": "271.87",
		"sixtyDay": "158.54",
		"ninetyDay": "114.98"
	},
	{
		"age": "53",
		"thirtyDay": "284.18",
		"sixtyDay": "165.96",
		"ninetyDay": "120.48"
	},
	{
		"age": "54",
		"thirtyDay": "297.22",
		"sixtyDay": "173.81",
		"ninetyDay": "126.5"
	},
	{
		"age": "55",
		"thirtyDay": "311.47",
		"sixtyDay": "182.41",
		"ninetyDay": "133.05"
	},
	{
		"age": "56",
		"thirtyDay": "326.86",
		"sixtyDay": "191.99",
		"ninetyDay": "140.46"
	},
	{
		"age": "57",
		"thirtyDay": "343.65",
		"sixtyDay": "202.54",
		"ninetyDay": "148.86"
	},
	{
		"age": "58",
		"thirtyDay": "362.06",
		"sixtyDay": "214.35",
		"ninetyDay": "158.22"
	},
	{
		"age": "59",
		"thirtyDay": "382.85",
		"sixtyDay": "227.8",
		"ninetyDay": "169.18"
	},
	{
		"age": "60",
		"thirtyDay": "403.35",
		"sixtyDay": "241.46",
		"ninetyDay": "180.59"
	},
	{
		"age": "61",
		"thirtyDay": "428.55",
		"sixtyDay": "258.55",
		"ninetyDay": "194.88"
	},
	{
		"age": "62",
		"thirtyDay": "456.96",
		"sixtyDay": "274.45",
		"ninetyDay": "205.31"
	},
	{
		"age": "63",
		"thirtyDay": "464.58",
		"sixtyDay": "275.65",
		"ninetyDay": "201.32"
	},
	{
		"age": "64",
		"thirtyDay": "341.42",
		"sixtyDay": "183.7",
		"ninetyDay": "111.01"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/git/qsuper-fed/~/json-loader!./src/data/standardRateUnitisedTwoYear.json
// module id = 456
// module chunks = 0